import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { authLoginRequest } from "config/apis/requests";
import { IsEmpty } from "config/functions";
import {
  all,
  estudante,
  senior,
  pcd,
  cadastroPrefeitura,
  atendenteAuditoria,
} from "variables/charts";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userCpf, setUserCpf] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erroLogin, setErroLogin] = useState("");

  useEffect(() => {
    const recoverLoggedUser = localStorage.getItem("user");
    if (recoverLoggedUser) {
      setUser(JSON.parse(recoverLoggedUser));
    }
  }, []);

  const loginCpf = () => {
    setUserCpf(localStorage.getItem("dataUserPrincipal"));
    return userCpf;
  };

  const login = async (user, pass, stayLogged) => {
    setLoading(true);
    const dataLogin = await authLoginRequest(user, pass);

    if (
      (!IsEmpty(dataLogin) && dataLogin != null) ||
      (dataLogin !== 400 && dataLogin !== 500)
    ) {
      const temPerfil = [
        all,
        estudante,
        senior,
        pcd,
        cadastroPrefeitura,
        atendenteAuditoria,
      ].some((grupo) =>
        dataLogin.usuario.perfis.some((perfil) => grupo.includes(perfil))
      );

      if (temPerfil) {
        if (stayLogged) {
          localStorage.setItem("stayLogged", JSON.stringify(stayLogged));
        }
        localStorage.setItem("user", JSON.stringify(dataLogin.usuario));
        sessionStorage.setItem("_bpAuth", dataLogin.token);

        axios.defaults.headers.Authorization =
          sessionStorage.getItem("_bpAuth");
        setLoading(false);
        setUser(dataLogin.usuario);
        setTimeout(function () {
          window.location.reload();
        }, 1);
      } else {
        setErroLogin("500");
        setLoading(false);
        logout();
      }
    } else {
      setErroLogin(dataLogin);
      setLoading(false);
      logout();
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("stayLogged");
    axios.defaults.headers.Authorization = sessionStorage.setItem(
      "_bpAuth",
      null
    );
  };

  return (
    <AuthContext.Provider
      value={{
        authenticated: !!user,
        user,
        loading,
        login,
        logout,
        loginCpf,
        erroLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
